export default "__VITE_ASSET__DwuixvOb__"